import { render, staticRenderFns } from "./quick-stats.vue?vue&type=template&id=39f5519d&scoped=true"
import script from "./quick-stats.vue?vue&type=script&lang=js"
export * from "./quick-stats.vue?vue&type=script&lang=js"
import style0 from "./quick-stats.vue?vue&type=style&index=0&id=39f5519d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5519d",
  null
  
)

export default component.exports